import { combineReducers } from "redux"
import { reducer as cardTable } from './cardTable/cardTableRedux'
export const reducer = combineReducers({
  cardTable,
})